import { Component, OnInit } from '@angular/core';
import { AutenticaCli } from '@laranda/lib-ucontrol';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  bodyText: string;

  constructor(
    public autenticaCli: AutenticaCli
  ) {

  }

  ngOnInit() {
    this.bodyText = 'This text can be updated in modal 1';
    this.autenticaCli.leerToken();
  }

  closeApp() {
    this.autenticaCli.logOut();
  }
}
